export const LOAD_BANNERS_REQUEST = 'LOAD_BANNERS_REQUEST';
export const LOAD_BANNERS_SUCCESS = 'LOAD_BANNERS_SUCCESS';
export const LOAD_BANNERS_FAIL = 'LOAD_BANNERS_FAIL';
